/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Pain_PointsInputs */

const en_footer_pain_points = /** @type {(inputs: Footer_Pain_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problems we solve`)
};

const lv_footer_pain_points = /** @type {(inputs: Footer_Pain_PointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problēmas, ko risinām`)
};

/**
* | output |
* | --- |
* | "Problems we solve" |
*
* @param {Footer_Pain_PointsInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const footer_pain_points = /** @type {((inputs?: Footer_Pain_PointsInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Pain_PointsInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_footer_pain_points(inputs)
	return en_footer_pain_points(inputs)
});